import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/(private)/resources")({
  component: ResourcesLayout,
});

function ResourcesLayout() {
  return <Outlet />;
}
